export const NEW_CONVERSATION_ID = -1

export const PRERENDERED_CONVO_ID = 'PRE-RENDER'
